import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import organizationApi from '@shared/api/organizationApi';

import alertsUtil from '@/util/alertsUtil';
import { dialogTypes, snackbarTypes } from '@/constants/alertTypes';
import { APIError } from '@shared/api';
import {
  ServiceAccount,
  ServiceAccountAPIKey
} from '@/features/account-settings/types';

type CreateApiKeyPayload = {
  organizationId: string;
  serviceAccountName: string;
};

const createApiKey = async (
  payload: CreateApiKeyPayload
): Promise<ServiceAccountAPIKey> => {
  const res = await organizationApi.createServiceAccountApiKey(payload);
  return res.data;
};

const useAddServiceAccountKeyMutatation = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation(createApiKey, {
    onSuccess: (res, variables) => {
      queryClient.setQueryData<ServiceAccount[]>(
        ['organizations', variables.organizationId, 'service-accounts'],
        data => {
          if (!data) return [];

          return data.map(account => {
            if (account.name === variables.serviceAccountName) {
              return {
                ...account,
                apiKeys: [res, ...account.apiKeys]
              };
            }

            return account;
          });
        }
      );

      dispatch(
        alertsUtil.openSnackbarDialog(
          snackbarTypes.SERVICE_ACCOUNT_REGENERATE_API_KEY,
          'Successfully added API key'
        )
      );
    },
    onError: (error: APIError) => {
      dispatch(
        alertsUtil.openErrorDialog(
          dialogTypes.CATCH_ERROR_API,
          error.response?.data.msg || 'An error occurred'
        )
      );
    }
  });
};

export default useAddServiceAccountKeyMutatation;
